<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M272 272h222.6a16 16 0 1 0 0-32H17.4a16 16 0 1 0 0 32z"/></svg>